<ng-template #voucherIneligibleModal let-modal>
  <div class="vim-wrap">

    <!-- HEADER -->
    <div class="vim-header">
      <h5 class="vim-title" id="voucher-ineligible-modal-title">
        Xác nhận voucher không hợp lệ
      </h5>
      <button
        type="button"
        class="vim-close-btn"
        aria-label="Đóng"
        (click)="onReview()"
      >
        <i class="ri-close-line"></i>
      </button>
    </div>

    <!-- SUBTITLE -->
    <p class="vim-subtitle">
      Đơn hàng của bạn hiện có voucher không thể áp dụng. Vui lòng kiểm tra lại.
    </p>

    <!-- VOUCHER LIST -->
    <div class="voucher-container">
      <app-voucher-item
        *ngFor="let item of displayItems"
        class="d-flex w-100"
        [voucher]="item.voucher"
        [errorMessage]="item.eligibility.displayMessage"
      ></app-voucher-item>
    </div>

    <!-- SUMMARY OF CART AFTER REMOVING INELIGIBLE VOUCHERS -->
    <div class="vim-cart-summary" *ngIf="cartAfter && cartAfter.finalPrice !== undefined">
      <p class="vim-summary-text">
        Tổng tiền dự kiến khi không áp dụng voucher:
        <strong class="vim-final-price">{{ cartAfter.finalPrice | currency:'VND':'symbol':'1.0-0' }}</strong>
      </p>
    </div>

    <!-- ACTIONS -->
    <div class="vim-footer">
      <button
        id="btn-voucher-continue"
        type="button"
        class="vim-btn-continue"
        (click)="onContinue()"
      >
        Đặt hàng mà không sử dụng voucher
      </button>
      <button
        id="btn-voucher-review"
        type="button"
        class="vim-btn-review"
        (click)="onReview()"
      >
        Kiểm tra lại giỏ hàng
      </button>
    </div>

  </div>
</ng-template>
